import styled from "styled-components";
import { Link } from "react-router-dom";

import { pxToRem } from "../../styles/utils";

export const BreadcrumbNav = styled.nav`
  width: 100%;
  min-width: 0;
  margin-bottom: ${pxToRem(14)};
  overflow: hidden;
`;

export const BreadcrumbList = styled.ol`
  display: flex;
  min-width: 0;
  align-items: center;
  gap: ${pxToRem(7)};
  margin: 0;
  padding: 0;
  list-style: none;
  color: ${({ theme }) => theme.colors.inkMuted};
  font-size: ${pxToRem(13)};
  line-height: 1.4;
  white-space: nowrap;
`;

export const BreadcrumbItem = styled.li`
  display: flex;
  min-width: 0;
  align-items: center;
  gap: ${pxToRem(7)};

  &:not(:last-child)::after {
    content: "";
    width: ${pxToRem(6)};
    height: ${pxToRem(6)};
    flex: 0 0 auto;
    border-top: ${pxToRem(1)} solid ${({ theme }) => theme.colors.inkMuted};
    border-right: ${pxToRem(1)} solid ${({ theme }) => theme.colors.inkMuted};
    transform: rotate(45deg);
    opacity: 0.55;
  }

  &:first-child {
    flex: 0 0 auto;
  }

  &:last-child {
    min-width: ${pxToRem(36)};
    flex: 1 1 auto;
  }
`;

const crumbText = `
  display: block;
  min-width: 0;
  max-width: 240px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const BreadcrumbLink = styled(Link)`
  ${crumbText};
  color: ${({ theme }) => theme.colors.inkSoft};
  text-decoration: none;
  transition: color 0.15s ease;

  &:hover {
    color: ${({ theme }) => theme.colors.brand};
  }

  &:focus-visible {
    border-radius: ${({ theme }) => pxToRem(theme.radii.sm)};
    outline: ${pxToRem(2)} solid ${({ theme }) => theme.colors.brand};
    outline-offset: ${pxToRem(2)};
  }

  @media (max-width: 720px) {
    max-width: 30vw;
  }
`;

export const BreadcrumbCurrent = styled.span`
  ${crumbText};
  max-width: 320px;
  color: ${({ theme }) => theme.colors.inkMuted};

  @media (max-width: 720px) {
    max-width: 34vw;
  }
`;
